<template>
  <button
    :class="buttonCss"
    :disabled="disabled"
    @click.stop="$emit('click')"
    type="button"
  >
    <icon :class="iconClass" :name="icon" v-if="icon" />
    <slot>{{text}}</slot>
  </button>
</template>

<script>
import Button from '@/mixins/Button';
import DynamicProps from '@/mixins/DynamicProps';

export default {
  name: 'common-button',
  mixins: [Button, DynamicProps],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconClass() {
      if (this.$slots.default || this.text) {
        return 'uk-margin-small-right';
      }
      return '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// CommonButton.vue?7b67926c